import React from 'react';

/**
 * Компонент хлебных крошек
 * 
 * Принимает:
 *   breadcrumbs - массив объектов из data?.breadcrumbs
 *     [
 *       {
 *         "@type": "ListItem",
 *         "position": 1,
 *         "item": {
 *           "@id": "http://...",
 *           "name": "Главная"
 *         }
 *       },
 *       ...
 *     ]
 * 
 * Логика:
 *   - Первый элемент ("Главная") отображается как иконка домика
 *   - Последний элемент — без ссылки (текущая страница)
 *   - Между элементами — разделитель ">"
 */
const Breadcrumbs = ({ breadcrumbs = [] }) => {
  if (!breadcrumbs || !Array.isArray(breadcrumbs) || breadcrumbs.length === 0) {
    return null;
  }

  // URL главной страницы — берём из первого элемента хлебных крошек
  const homeUrl = breadcrumbs[0]?.item?.['@id'];

  return (
    <div className='max-w-full overflow-x-auto inline-flex items-center px-[15px] h-auto py-[10px] bg-[#F5F7F9] rounded-[17px] gap-[5px] text-[14px] whitespace-nowrap'>
      {/* Иконка "сундучок" — ссылка на главную */}
      <a
        href={homeUrl}
        className='flex-none hover:opacity-80 transition-opacity'
        aria-label='Главная'
      >
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15 6.1875V13.5C15 15.75 13.6575 16.5 12 16.5H6C4.3425 16.5 3 15.75 3 13.5V6.1875C3 3.75 4.3425 3.1875 6 3.1875C6 3.6525 6.18748 4.0725 6.49498 4.38C6.80248 4.6875 7.2225 4.875 7.6875 4.875H10.3125C11.2425 4.875 12 4.1175 12 3.1875C13.6575 3.1875 15 3.75 15 6.1875Z" stroke="#032432" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M12 3.1875C12 4.1175 11.2425 4.875 10.3125 4.875H7.6875C7.2225 4.875 6.80248 4.6875 6.49498 4.38C6.18748 4.0725 6 3.6525 6 3.1875C6 2.2575 6.7575 1.5 7.6875 1.5H10.3125C10.7775 1.5 11.1975 1.6875 11.505 1.995C11.8125 2.3025 12 2.7225 12 3.1875Z" stroke="#032432" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M6 9.75H9" stroke="#032432" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M6 12.75H12" stroke="#032432" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </a>

      <div className='tracking-[-0.04em] flex flex-wrap items-center gap-[9px] text-[#032432]'>
        {breadcrumbs.map((crumb, index) => {
          const isFirst = index === 0;
          const isLast = index === breadcrumbs.length - 1;
          const name = crumb?.item?.name;
          const url = crumb?.item?.['@id'];

          return (
            <React.Fragment key={crumb.position || index}>
              {/* Первый элемент ("Главная") — иконка домика */}
              {isFirst ? (
                <>
                </>
              ) : isLast ? (
                /* Последний элемент — без ссылки */
                <div className='text-[#032432]'>{name}</div>
              ) : (
                /* Промежуточные элементы — ссылки */
                <a
                  href={url}
                  className='text-[#032432]/60 hover:text-[#009EE3] transition-colors'
                >
                  {name}
                </a>
              )}
              {/* Разделитель перед каждым элементом, кроме первого */}
              {!isFirst && !isLast && (
                <svg width="5" height="12" viewBox="0 0 5 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0.433594 0.249512L3.60283 5.74951L0.433594 11.2495" stroke="#032432" strokeOpacity="0.6"/>
                </svg>
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};

export default Breadcrumbs;
